var resize_boxy = window.resize_boxy;
var request_resize = window.request_resize;
var handlePostMessage = window.handlePostMessage;
var handlePostMessage, request_resize, resize_boxy;
resize_boxy = function (e, size) {
  var boxy;
  boxy = _.find(Widgets.Base.open_widgets || [], function (widget) {
    return widget.widget_name === "BoxOver";
  });
  if (size != null && boxy != null) {
    return boxy.set_height(size);
  }
};
request_resize = function (e, size) {
  if (window.location === window.parent.location) {
    return resize_boxy(e, size);
  } else {
    return window.parent.postMessage({
      'event': 'resize_boxy',
      'size': size
    }, "*");
  }
};
$(document).on('resize_boxy', request_resize);
handlePostMessage = function (e) {
  if (e.data && e.data.hasOwnProperty('event') && e.data.event === "resize_boxy") {
    return request_resize(e, e.data.size);
  }
};
window.addEventListener("message", handlePostMessage, false);
window.handlePostMessage = handlePostMessage;
window.request_resize = request_resize;
window.resize_boxy = resize_boxy;